var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { useContext, useEffect } from "react";
import { ModalContext, RicosContext } from "./../../../../ricos-context";
import { FloatingCustomColorPicker } from "./floating-custom-color-picker";
const CUSTOM_COLOR_PICKER_MODAL_ID = "custom-color-picker-modal-id";
const useCustomColorPickerModal = ({
  onClickOutside,
  componentProps
}) => {
  const { isMobile } = useContext(RicosContext);
  const modalService = useContext(ModalContext);
  useEffect(() => {
    !modalService.getModal(CUSTOM_COLOR_PICKER_MODAL_ID) && modalService.register({
      Component: FloatingCustomColorPicker,
      id: CUSTOM_COLOR_PICKER_MODAL_ID,
      noPadding: true
    });
  }, []);
  const toggleModal = (ref) => {
    if (isModalOpen()) {
      return closeModal();
    }
    const props = __spreadProps(__spreadValues({}, componentProps), {
      onCancel: closeModal
    });
    return modalService.openModal(CUSTOM_COLOR_PICKER_MODAL_ID, {
      positioning: { placement: isMobile ? "bottom" : "left-start", referenceElement: ref },
      layout: isMobile ? "fullscreen" : "popover",
      onClickOutside: (e) => {
        if (ref && ref.contains(e.target)) {
          closeModal();
          return;
        }
        closeModal();
        onClickOutside();
      },
      componentProps: props
    });
  };
  const closeModal = () => modalService.closeModal(CUSTOM_COLOR_PICKER_MODAL_ID);
  const isModalOpen = () => modalService.isModalOpen(CUSTOM_COLOR_PICKER_MODAL_ID);
  return { toggleModal, closeModal, isModalOpen };
};
export {
  useCustomColorPickerModal
};
//# sourceMappingURL=use-custom-color-picker-modal.js.map
